export enum LogoutType {
  USER = 'USER',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
}
